export default "__VITE_ASSET__C028i413__"